import ActionTypes from '../../actionTypes'
const { GET_ALL_DATA_FAIL, GET_ALL_DATA_SUCCESS } = ActionTypes.REPORTS.KM_SUMMARY

const initialState = {
  allKmSummary: [],
  dataCount: 0,
}

const kmSummaryReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case GET_ALL_DATA_SUCCESS:
      return {
        ...state,
        allKmSummary: payload.rows,
        dataCount: payload.count,
      }
    case GET_ALL_DATA_FAIL:
      return {
        ...state,
        allKmSummary: [],
        dataCount: 0,
      }
    default:
      return state
  }
}

export default kmSummaryReducer
